module.exports = __webpack_public_path__ + "img/bp2_gift1_dis.a02bca21.png";